import React from 'react';
import { useIntl } from 'react-intl';
import { faPhotoFilm } from '@fortawesome/pro-light-svg-icons/faPhotoFilm';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { SMLEmptyState } from '../../components/SMLEmptyState/SMLEmptyState';
import { postsMessages } from './postsMessages';

interface PostsEmptyProps {
  readOnly: boolean;
  onPlanRollout: () => void;
  onNewPost: () => void;
}

/**
 * No post files at all (design assets-rethink d2): "No posts to make yet", with "Plan a rollout"
 * (the Releases list) and "New post" (the Composer).
 */
const PostsEmptyComponent: React.FC<PostsEmptyProps> = ({ readOnly, onPlanRollout, onNewPost }) => {
  const intl = useIntl();
  return (
    <div data-testid="posts-empty">
      <SMLEmptyState
        icon={faPhotoFilm}
        title={intl.formatMessage(postsMessages.emptyTitle)}
        description={intl.formatMessage(postsMessages.emptyBody)}
        action={readOnly ? undefined : { label: intl.formatMessage(postsMessages.planRollout), onClick: onPlanRollout }}
      />
      {!readOnly && (
        <div className="d-flex justify-content-center mt-2">
          <SMLButton color="secondary" outline size="sm" omitCap onClick={onNewPost}>
            {intl.formatMessage(postsMessages.newPost)}
          </SMLButton>
        </div>
      )}
    </div>
  );
};

export const PostsEmpty = TypedMemo(PostsEmptyComponent);
